import { Button, Form, Input, Modal, Result, Typography } from 'antd';
import { useAuthStateContext } from 'providers/Auth';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { sendContactUs } from 'services/api/contactUs';

import { showRestError } from 'utils/showErrorMessage';
import { pickLocale } from 'utils/pickLocale';

const { Title } = Typography;

const ContactUs = () => {
  const { t, i18n } = useTranslation();
  const [form] = Form.useForm();
  const [isVisible, setVisible] = useState(false);
  const [isSucceed, setSucceed] = useState(false);
  const [loading, setLoading] = useState(false);
  const { user } = useAuthStateContext();

  const onFinish = (values: { description: string }) => {
    setLoading(true);
    sendContactUs({
      firstName: pickLocale(user?.first_name, i18n.language),
      lastName: pickLocale(user?.last_name, i18n.language),
      phoneNumber: user?.phone || '',
      email: user?.email,
      description: values?.description
    })
      .then(() => {
        setSucceed(true);
      })
      .catch(err => showRestError(err))
      .finally(() => setLoading(false));
  };

  const onCancel = () => {
    form.resetFields();
    setVisible(false);
    setSucceed(false);
  };

  return (
    <>
      <Button onClick={() => setVisible(true)} block>
        {t('header.contact_us')}
      </Button>
      {isVisible && (
        <Modal
          title={
            isSucceed ? null : (
              <Title level={4}>{t('contact_us.how_can_help')}</Title>
            )
          }
          onCancel={onCancel}
          okText={t('contact_us.submit')}
          footer={isSucceed ? null : undefined}
          confirmLoading={loading}
          onOk={() => form.submit()}
          cancelButtonProps={{ disabled: loading }}
          closable={!loading}
          centered
          open
        >
          {isSucceed ? (
            <Result
              status="success"
              title={t('contact_us.success_title')}
              subTitle={t('contact_us.success_text')}
            />
          ) : (
            <Form
              form={form}
              onFinish={onFinish}
              layout="vertical"
              size="large"
            >
              <Form.Item
                name="description"
                rules={[{ required: true, message: '' }]}
              >
                <Input.TextArea className="contact-us-textarea" />
              </Form.Item>
            </Form>
          )}
        </Modal>
      )}
    </>
  );
};

export default ContactUs;
